import LanguageLocale from 'utils/LanguageLocale';
import { Link, Text, Box } from 'components/ui';
import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { colors, lineHeights, space } from 'style/config';
import SddSectionEN from 'components/FrictionlessCheckout/SddSection/locales/SddSection_en_US';
import SddSectionFR from 'components/FrictionlessCheckout/SddSection/locales/SddSection_fr_CA';

const { getLocalisedDataFromResource } = LanguageLocale;
const getText = getLocalisedDataFromResource(SddSectionEN, SddSectionFR);

const SameDaySkuOOSException = ({ addMarginBottom, hasPadding, addMarginTop }) => (
    <Box
        marginBottom={addMarginBottom && space[1]}
        paddingX={hasPadding && [space[1], 5]}
        marginTop={addMarginTop && space[1]}
        lineHeight={lineHeights.tight}
    >
        <Text color={colors.red}>
            {`${getText('oosError')} `}
            <Link
                href='/basket'
                color={colors.blue}
            >
                {getText('oosBasket')}
            </Link>
            {` ${getText('oosUpdate')}`}
        </Text>
    </Box>
);

SameDaySkuOOSException.defaultProps = {};
SameDaySkuOOSException.propTypes = {};

export default wrapFunctionalComponent(SameDaySkuOOSException, 'SameDaySkuOOSException');
